import React from "react";
import styled from "styled-components";
import { mobile } from "../responsive";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://images.pexels.com/photos/6984661/pexels-photo-6984661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940")
      center;
  display: flex;
  background-size: cover;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 40%;
  padding: 20px;
  background-color: #f7f8f8;
  ${mobile({ width: "75%" })}
`;
const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 300;
`;
const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;
const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0 0;
  padding: 10px;
`;
const Agreement = styled.span`
  font-size: 0.8rem;
  margin: 20px 0;
`;
const Button = styled.button`
  width: 40%;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 15px;
  background-color: teal;
  color: white;
  cursor: pointer;
`;

export const Register = () => {
  const navigate = useNavigate();
  const navigateTo =  () => navigate.push("/");
 
  return (
    <Container>
      <Wrapper>
        <Title>CREATE A ACCOUNT</Title>
        <Form>
          <Input placeholder="Name" />
          <Input placeholder="last name" />
          <Input placeholder="username" />
          <Input placeholder="email" />
          <Input placeholder="password" />
          <Input placeholder="confirm password" />
          <Agreement>
            By creating an account, I consent to the processing of my personal
            data in accordance with the <b>PRIVACY POLICY</b>
          </Agreement>
          <Button onClick={navigateTo}> CREATE</Button>
        </Form>
      </Wrapper>
    </Container>
  );
};
export default Register;
